/**
 * Simple Newsletter Tracking
 * Listens for newsletter form submissions and pushes to dataLayer
 */
(function() {
  'use strict';

  // To support an ask that we publish a newsletter signup to Shopify analytics, we need to handle both the native Liquid form and the Privy embed which is in a cross-origin iframe. This function handles the event that is captured from the Privy message passed up to the window from the iframe.
  function handlePrivyMessage(event) {

    // Verify the message origin to ensure it's from Privy's iframe.
    // Note: Privy may change their domain in the future, requiring an update here.
    if (event.origin !== 'https://promotions.lpage.co') {
      return;
    }

    try {
      // The expectation is that the privy event data will be JSON but we are going to guard against a potential parse failure if that changes in the future.
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      const messageType = data.messageType || '';

      if (messageType.includes('submit success')) {
        const emailHash = data.transaction?.customer?.email_lc_sha256 || null;

        if (emailHash) {
          const privySubscribeEvent = {
            event: 'newsletter_subscription',
            event_source: 'privy_embed',
            customer_email: emailHash
          };

          window.Shopify.analytics.publish('newsletter_subscription', privySubscribeEvent);
        } else {
          console.info('[Newsletter Tracking] No email hash available. Skipping push to data layer.');
        }
      }
    } catch (err) {
      console.error('[Newsletter Tracking] Error parsing event data:', err);
    }
  }

  function init() {
    // Listen for iframe messages (Privy submissions)
    window.addEventListener('message', handlePrivyMessage);
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
